// removed by extract-text-webpack-plugin
module.exports = {"app":"app___31MH8","appContent":"appContent___32OVM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/App.scss
// module id = xgTf
// module chunks = 46